export default () => {
  let combos = document.querySelectorAll('.fake-select');

  Array.prototype.forEach.call(combos, function (combo, index) {
    let parent = combo.parentNode;
    let select = parent.querySelectorAll('select')[0];
    let list = combo.querySelectorAll('ul')[0];
    let label = combo.querySelectorAll('label')[0];
    let listItems = list.querySelectorAll('li');

    Array.prototype.forEach.call(listItems, function (item, index) {
      item.addEventListener('click', function () {
        document.removeEventListener('click', closeAllCombos);
        let list = item.parentNode;
        list.classList.remove('open');
        parent.classList.remove('open');
        label.innerHTML = item.innerHTML;
        select.value = item.dataset.value;

        let e = new Event('change');
        select.dispatchEvent(e);
      });

      if (item.classList.contains('selected')) {
        label.innerHTML = item.innerHTML;
      }
    });

    label.addEventListener('click', function () {
      document.removeEventListener('click', closeAllCombos);
      if (list.classList.contains('open')) {
        list.classList.remove('open');
        parent.classList.remove('open');
      } else {
        list.classList.add('open');
        parent.classList.add('open');
        setTimeout(() => {
          document.addEventListener('click', closeAllCombos);
        }, 500);
      }
    });
  });

  function closeAllCombos() {
    document.removeEventListener('click', closeAllCombos);
    Array.prototype.forEach.call(combos, function (combo, index) {
      let list = combo.querySelectorAll('ul')[0];
      let parent = combo.parentNode;
      list.classList.remove('open');
      parent.classList.remove('open');
    });
  }
};
